import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {UtilService} from "../../../services/util.service";


@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit {
  @Input() items: any[];
  @Input() currentPath: string;
  @ViewChild('childMenu', {static: true}) public childMenu: any;
  constructor(public utilService: UtilService) { }

  ngOnInit(): void {
  }

}
